// components/dialogs/SaveRoundResultDialog.js
import React, { useEffect, useMemo, useState } from 'react';
import BaseDialog from '../BaseDialog';
import useApiControl from '../../../common/useApiControl';
import { Button, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';
import Box from '@mui/material/Box';

const SaveRoundResultDialog = ({ isVisible, onClose, round, nextRoundStart, dialogMode, containerRef }) => {
  const [result, setResult] = useState('');
  const [choices, setChoices] = useState([]);
  const [message, setMessage] = useState('');

  const params = useMemo(() => ({
    eid: round?.event_id,
    result: result
  }), [round?.event_id, result]);

  const { executeRequest: saveResult, loading } = useApiControl({
    action: '/save_round_result',
    params: params,
    method: 'POST',
  });

  useEffect(() => {
    if (round?.answers) {
      try {
        const parsed = JSON.parse(round.answers);
        setChoices(parsed);
      } catch (e) {
        console.error("Error parsing answers JSON", e);
        setChoices([]);
      }
    } else {
      setChoices([]);
    }
  }, [round?.answers]);

  useEffect(() => {
    setResult('');
    setMessage('');
  }, [round?.id, round?.result, isVisible]);

  const handleSave = async () => {
    if (result !== '') {
      try {
        setMessage('');
        await saveResult();
        await nextRoundStart();
        onClose();
      } catch (error) {
        setMessage(error?.response?.data?.message || '仮結果の登録に失敗しました。');
      }
    }
  };

  return (
    <BaseDialog
      isVisible={isVisible}
      onClose={onClose}
      dialogMode={dialogMode}
      containerRef={containerRef}
      maxWidth="min(92vw, 360px)"
      padding="10px"
    >
      <div style={{ maxWidth: '340px', padding: 0 }}>
        <h2 style={{ fontSize: '15px', margin: '0 0 5px' }}>
          ベットタイムが終了しました。
        </h2>
        <h3 style={{ fontSize: '13px', lineHeight: 1.35, margin: '0 0 6px' }}>
          結果を選択してください。選択結果は仮結果として参加者に通知されます。
        </h3>
        <p style={{ fontSize: '12px', color: '#666', margin: '0 0 8px' }}>
          ※この選択で結果は確定しません。
        </p>
        {message && (
          <p style={{ fontSize: '12px', color: '#b91c1c', margin: '0 0 8px' }}>
            {message}
          </p>
        )}

        {round?.type === 0 && (
          <FormControl component="fieldset" sx={{ width: '100%' }}>
            <FormLabel component="legend" sx={{ fontSize: '12px', mb: 0.25 }}>選択肢</FormLabel>
            <RadioGroup
              value={result}
              onChange={(e) => setResult(e.target.value)}
            >
              {choices.map((choice, index) => (
                <FormControlLabel
                  key={index}
                  value={String(index)}
                  control={<Radio size="small" sx={{ py: 0.25 }} />}
                  label={choice}
                  sx={{ mx: 0, my: 0.1, '& .MuiFormControlLabel-label': { fontSize: '13px' } }}
                />
              ))}
            </RadioGroup>
            <Box sx={{ mt: 0.75, display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                variant="contained"
                size="small"
                onClick={handleSave}
                disabled={result === '' || loading}
              >
                決定する
              </Button>
            </Box>
          </FormControl>
        )}

        {round?.type === 1 && (
          <p>タイプ1の処理は未実装です。</p>
        )}
      </div>
    </BaseDialog>
  );
};

export default SaveRoundResultDialog;
